import styled from 'styled-components';

import { TThemeType } from '_style/style';

export interface StyledIconProps {
  $color?: keyof TThemeType['color'];
  $iconSize?: string;
  $size?: number;
}

export const StyledSvgWrapper = styled.div.attrs<StyledIconProps>(
  ({ $size }) => ({
    $iconSize: $size ? `${$size}px` : '32px',
  }),
)<StyledIconProps>`
  display: flex;
  width: ${({ $iconSize }) => $iconSize};
  height: ${({ $iconSize }) => $iconSize};
  color: inherit;

  svg {
    width: ${({ $iconSize }) => $iconSize};
    height: ${({ $iconSize }) => $iconSize};
    fill: currentcolor;
    stroke: currentcolor;
    stroke-width: 0;
  }

  ${({ $color, theme }) =>
    $color &&
    `
    color: ${theme.color[$color]};
  `}
`;
